



























import { defineComponent } from '@vue/composition-api';
import { useUser } from '../../store/modules/user';
import ApiKeys from '../api-keys/ApiKeys.vue';

export default defineComponent({
	components: {
		ApiKeys,
	},
	setup(_, { root }) {
		const { user, isLoading, isLoaded, hasError } = useUser(root.$store);

		return {
			isLoading,
			isLoaded,
			hasError,
			user,
		};
	},
});
